import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API, formatUsd } from "../../config/trading";
import { apiErrorMessage } from "../../lib/errorMessage";

export function ProfilePage({ user, token, onProfileUpdated }) {
  const [form, setForm] = useState({ name: user.name, current_password: "", new_password: "" });
  const [share, setShare] = useState(null);
  const [message, setMessage] = useState("");

  const loadShare = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/auth/me/earning-share`, { headers: { Authorization: `Bearer ${token}` } });
      setShare(response.data);
    } catch {
      setShare(null);
    }
  }, [token]);

  useEffect(() => { loadShare(); }, [loadShare]);

  const save = async () => {
    try {
      const response = await axios.patch(`${API}/auth/me`, form, { headers: { Authorization: `Bearer ${token}` } });
      onProfileUpdated(response.data);
      setMessage("Profile updated.");
      setForm((current) => ({ ...current, current_password: "", new_password: "" }));
    } catch (err) {
      setMessage(apiErrorMessage(err, "Profile could not be updated."));
    }
  };

  return (
    <main className="terminal-shell" data-testid="profile-page">
      <section className="panel profile-panel">
        <span className="label">PROFILE</span>
        <h1>{user.name}</h1>
        <div className="profile-grid">
          <div className="metric"><span className="label">Email</span><strong data-testid="profile-email">{user.email}</strong></div>
          <div className="metric"><span className="label">Role</span><strong data-testid="profile-role">{user.role}</strong></div>
          <div className="metric"><span className="label">Status</span><strong data-testid="profile-status">{user.active ? "Active" : "Disabled"}</strong></div>
          <div className="metric"><span className="label">Membership</span><strong data-testid="profile-membership">{user.membership_type}</strong></div>
          <div className="metric"><span className="label">Term</span><strong data-testid="profile-term">{user.membership_term?.replaceAll("_", " ")}</strong></div>
          <div className="metric"><span className="label">USDT Investment</span><strong data-testid="profile-investment">{formatUsd(user.usdt_investment || 0)}</strong></div>
          <div className="metric"><span className="label">Applied %</span><strong data-testid="profile-applied-percent">{share?.applied_percentage ?? user.short_term_percentage}%</strong></div>
          <div className="metric"><span className="label">Earning Share</span><strong data-testid="profile-earning-share">{formatUsd(share?.calculated_active_share || 0)}</strong></div>
          <div className="metric"><span className="label">Funds Balance</span><strong data-testid="profile-funds-balance">{formatUsd(share?.funding_balance_usdt || user.funding_balance_usdt || 0)}</strong></div>
        </div>
        <div className="admin-create-grid">
          <input data-testid="profile-name-input" className="terminal-input" value={form.name} onChange={(event) => setForm((current) => ({ ...current, name: event.target.value }))} />
          <input data-testid="profile-current-password-input" className="terminal-input" type="password" placeholder="Current password" value={form.current_password} onChange={(event) => setForm((current) => ({ ...current, current_password: event.target.value }))} />
          <input data-testid="profile-new-password-input" className="terminal-input" type="password" placeholder="New password" value={form.new_password} onChange={(event) => setForm((current) => ({ ...current, new_password: event.target.value }))} />
          <button data-testid="profile-save-button" className="primary-button" onClick={save}>Save Profile</button>
        </div>
        {message && <p className="notice" data-testid="profile-message">{message}</p>}
      </section>
    </main>
  );
}